export interface Coordinates {
  top: number
  left: number
}
